import type { GuideTourDefinition, GuideTourRegistry } from '../types'
import {
  getGuideTourDefaultPriority,
  isGuideTourAvailable,
  tourIsSingleRoute,
  tourMatchesPathname,
} from '../routing/utils'

const tourShowsGuideTourButton = (tour: GuideTourDefinition): boolean =>
  tour.guideTourButton === true

/** Highest-priority eligible tour on `pathname` (ignores seen/dismiss). */
export const selectGuideTourForButton = (
  pathname: string,
  registry: GuideTourRegistry,
  now: Date = new Date()
): GuideTourDefinition | undefined =>
  registry
    .listGuideTours()
    .filter(
      tour =>
        tourShowsGuideTourButton(tour) &&
        tourIsSingleRoute(tour) &&
        isGuideTourAvailable(tour, now) &&
        tourMatchesPathname(tour, pathname)
    )
    .sort((left, right) => {
      const priorityDiff =
        getGuideTourDefaultPriority(right) - getGuideTourDefaultPriority(left)

      if (priorityDiff !== 0) {
        return priorityDiff
      }

      return left.id.localeCompare(right.id)
    })[0]
